module.exports = __webpack_public_path__ + "img/detail-avatar-detail.04f0301d.png";